// removed by extract-text-webpack-plugin
module.exports = {"root":"Tip_root_2bp","inner":"Tip_inner_2Ui","title":"Tip_title_3Tx","body":"Tip_body_3TW","slideOutRight":"Tip_slideOutRight_3ux","slideInRight":"Tip_slideInRight_3oC","hide":"Tip_hide_39R"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tip/Tip.css
 ** module id = 571
 ** module chunks = 0
 **/